import React from "react";
//#region types
import { EmployeeProfileProps } from "models/propTypes/userProfilePropTypes";
import { SettingsFormTypes } from "models/formTypes";
//#endregion
//#region components
import Person from "./person";
import { useFormikContext } from "formik";
//#endregion
import { UrlHelper } from "utils/helpers";

const EmployeeProfileLink: React.FC<EmployeeProfileProps> = (props) => {
  const { values } = useFormikContext<SettingsFormTypes.SalarySettings>();
  if (!values.salarySettings || !props.value) return <></>;

  // eslint-disable-next-line eqeqeq --- disabling to avoid regression testing if changed
  const row = values.salarySettings.find((m) => m.id == props.value);
  if (!row) return <></>;

  const url = UrlHelper.formatPath(`/Employee/${row.id}`);

  return <Person id={row.id} name={row.name} href={url} className={props.className} />;
};

export default EmployeeProfileLink;
